import { LeagueTeam } from "../store/leagues";

export interface GeneratedFixture {
  round_number: number;
  fixture_order: number;
  team_a_id: string | null;
  team_a_name: string;
  team_b_id: string | null;
  team_b_name: string;
}

export type CompetitionType =
  | "round_robin"
  | "double_round_robin"
  | "league_final"
  | "ROUND_ROBIN_PLAYOFFS"
  | "custom";

export function generateRoundRobinFixtures(teams: LeagueTeam[]): GeneratedFixture[] {
  if (teams.length < 2) {
    return [];
  }

  const fixtures: GeneratedFixture[] = [];
  let fixtureOrder = 0;

  for (let i = 0; i < teams.length; i++) {
    for (let j = i + 1; j < teams.length; j++) {
      fixtures.push({
        round_number: 1,
        fixture_order: fixtureOrder++,
        team_a_id: teams[i].id,
        team_a_name: teams[i].team_name,
        team_b_id: teams[j].id,
        team_b_name: teams[j].team_name,
      });
    }
  }

  return fixtures;
}

export function generateDoubleRoundRobinFixtures(teams: LeagueTeam[]): GeneratedFixture[] {
  if (teams.length < 2) {
    return [];
  }

  const fixtures: GeneratedFixture[] = [];
  let fixtureOrder = 0;

  for (let i = 0; i < teams.length; i++) {
    for (let j = i + 1; j < teams.length; j++) {
      fixtures.push({
        round_number: 1,
        fixture_order: fixtureOrder++,
        team_a_id: teams[i].id,
        team_a_name: teams[i].team_name,
        team_b_id: teams[j].id,
        team_b_name: teams[j].team_name,
      });
    }
  }

  for (let i = 0; i < teams.length; i++) {
    for (let j = i + 1; j < teams.length; j++) {
      fixtures.push({
        round_number: 2,
        fixture_order: fixtureOrder++,
        team_a_id: teams[j].id,
        team_a_name: teams[j].team_name,
        team_b_id: teams[i].id,
        team_b_name: teams[i].team_name,
      });
    }
  }

  return fixtures;
}

export function generateLeagueFinalFixtures(teams: LeagueTeam[]): GeneratedFixture[] {
  if (teams.length < 2) {
    return [];
  }

  const fixtures: GeneratedFixture[] = [];
  let fixtureOrder = 0;

  for (let i = 0; i < teams.length; i++) {
    for (let j = i + 1; j < teams.length; j++) {
      fixtures.push({
        round_number: 1,
        fixture_order: fixtureOrder++,
        team_a_id: teams[i].id,
        team_a_name: teams[i].team_name,
        team_b_id: teams[j].id,
        team_b_name: teams[j].team_name,
      });
    }
  }

  fixtures.push({
    round_number: 2,
    fixture_order: fixtureOrder++,
    team_a_id: null,
    team_a_name: "TBD",
    team_b_id: null,
    team_b_name: "TBD",
  });

  return fixtures;
}

export function generateRoundRobinPlayoffsFixtures(teams: LeagueTeam[]): GeneratedFixture[] {
  if (teams.length < 2) {
    return [];
  }

  const fixtures = generateRoundRobinFixtures(teams);
  const lastRound = fixtures.reduce((max, f) => Math.max(max, f.round_number), 1);
  let fixtureOrder = fixtures.length;

  const semiRound = lastRound + 1;
  fixtures.push({
    round_number: semiRound,
    fixture_order: fixtureOrder++,
    team_a_id: null,
    team_a_name: "1st Place",
    team_b_id: null,
    team_b_name: "4th Place",
  });
  fixtures.push({
    round_number: semiRound,
    fixture_order: fixtureOrder++,
    team_a_id: null,
    team_a_name: "2nd Place",
    team_b_id: null,
    team_b_name: "3rd Place",
  });

  fixtures.push({
    round_number: lastRound + 2,
    fixture_order: fixtureOrder++,
    team_a_id: null,
    team_a_name: "Winner SF1",
    team_b_id: null,
    team_b_name: "Winner SF2",
  });

  return fixtures;
}

export function generateFixturesByType(
  competitionType: CompetitionType,
  teams: LeagueTeam[]
): GeneratedFixture[] {
  switch (competitionType) {
    case "round_robin":
      return generateRoundRobinFixtures(teams);
    case "double_round_robin":
      return generateDoubleRoundRobinFixtures(teams);
    case "league_final":
      return generateLeagueFinalFixtures(teams);
    case "ROUND_ROBIN_PLAYOFFS":
      return generateRoundRobinPlayoffsFixtures(teams);
    case "custom":
      return [];
    default:
      return generateRoundRobinFixtures(teams);
  }
}
